import { ServiceFetch } from './service-fetch'

export default class CustomerModel extends ServiceFetch {
    checkLogin = (data) => this.authFetch({
        url: 'customer/checkLogin',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByCode = (data) => this.authFetch({
        url: 'customer/getCustomerByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByLineID = (data) => this.authFetch({
        url: 'customer/getCustomerByLineID',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerReceipt = (data) => this.authFetch({
        url: 'customer/getCustomerReceipt',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerLineBy = (data) => this.authFetch({
        url: 'customer/updateCustomerLineBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerPassword = (data) => this.authFetch({
        url: 'customer/updateCustomerPassword',
        method: 'POST',
        body: JSON.stringify(data),
    })
}